import React from 'react'
import PropTypes from 'prop-types'
import { Popover, Menu, MenuItem, Snackbar } from 'material-ui'
import styles from './styles/HelperDialogs.js'

// helper components for Sliders

export const AddDialog = (props) => {
  let messageTypes

  if (!props.userTier || props.userTier !== 4) {
    messageTypes = ['Text', 'Email']
  } else {
    messageTypes = ['Email']
  }

  const menuItems = messageTypes.map(msgType => (
    <MenuItem primaryText={msgType} key={msgType} onClick={props.addHandle} />
  ))

  return (
    <Popover
      open={props.isOpen}
      anchorEl={props.anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'left', vertical: 'top' }}
      onRequestClose={props.closeAddDialog}
    >
      <Menu>{menuItems}</Menu>
    </Popover>
  )
}

AddDialog.propTypes = {
  userTier: PropTypes.number,
}

export const UndoDeleteDialog = props => (
  <Snackbar
    open={props.isOpen}
    message={'Setting Deleted'}
    style={styles.undoDelete}
    action="undo"
    autoHideDuration={15000}
    onActionTouchTap={props.handleUndoAction}
    onRequestClose={props.closeUndoDialog}
  />
)



// WEBPACK FOOTER //
// ./src/components/Settings/Dialogs.js